import type { Resource } from '@/api/core/native-presentation';
import type { PropertyCatalog } from '@/api/core/properties';
import { useState } from 'react';
import type { PropertyRuntime } from '../property-queries';
import { Choice } from './choice';
import { PresentationEditor } from './presentation-editor';
export function LegacyPresentationSection({
  runtime,
  catalog,
}: {
  runtime: PropertyRuntime;
  catalog: PropertyCatalog;
}) {
  const [selected, setSelected] = useState('property');
  const targets: { key: string; resource: Resource; id: string; label: string }[] = [
    {
      key: 'property',
      resource: 'properties',
      id: catalog.property.property_id,
      label: catalog.property.name,
    },
    ...catalog.roomTypes
      .filter((t) => t.sourceDeletedMarker === null)
      .map((t) => ({
        key: `type:${t.id}`,
        resource: 'room-types' as const,
        id: t.id,
        label: `유형 · ${t.name}`,
      })),
    ...catalog.rooms
      .filter((r) => r.sourceDeletedMarker === null)
      .map((r) => ({
        key: `room:${r.id}`,
        resource: 'rooms' as const,
        id: r.id,
        label: `객실 · ${String(r.roomNo)}`,
      })),
    ...catalog.slots
      .filter(
        (u) =>
          u.sourceDeletedMarker === null &&
          catalog.rooms.some((r) => r.id === u.roomId && r.sourceDeletedMarker === null),
      )
      .map((u) => ({
        key: `unit:${u.id}`,
        resource: 'units' as const,
        id: u.id,
        label: `판매 공간 · ${u.slotNo}`,
      })),
  ];
  const target = targets.find((t) => t.key === selected) ?? targets[0];
  if (!target) return null;
  return (
    <section className="space-y-3">
      <Choice
        label="이름·콘텐츠 수정 대상"
        value={target.key}
        disabled={false}
        options={Object.fromEntries(targets.map((t) => [t.key, t.label]))}
        onChange={setSelected}
      />
      <PresentationEditor
        key={target.key}
        legacyProperty
        runtime={runtime}
        propertyId={catalog.property.property_id}
        resource={target.resource}
        id={target.id}
        label={target.label}
      />
    </section>
  );
}
